import { render, staticRenderFns } from "./RoomTypeDropdown.vue?vue&type=template&id=2b281a7e&"
import script from "./RoomTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./RoomTypeDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RoomTypeDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem})
